import React from "react";
import "./index.scss";
import { docProps, sectionProps } from "./types";
import Dropdown from "../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../static/Dropdown/types";
import { createLabel } from "../../helpers";

export interface GenericNavDropdownOption {
  id?: number;
  url: string;
  name: string;
  selected?: Boolean;
}

interface GenericDropdownProps {
  options: GenericNavDropdownOption[];
  value?: dropdownItem;
  placeholder?: string;
  classes?: string;
}

export const GenericDropdown = ({
  options = [],
  value,
  placeholder,
  classes = ""
}: GenericDropdownProps) => (
  <Dropdown
    onChange={({ url }: any) => {
      location.href = `${location.origin}${url}`;
    }}
    className={classes}
    options={createLabel(options)}
    value={value}
    placeholder={placeholder}
  />
);

const landingPageProps = {
  description:
    "Find out more about what we do to deliver tennis across the globe.",
  title:
    "We're the world governing body of tennis, working on behalf of our 210 member nations.",
  linkText: "Find out more"
};

export const ImageGrid = ({ images = [] }: any) => (
  <div className="landing-page__image-grid">
    {images.map(({ src, link }: any) => (
      <a href={link}>
        <img src={src} />
      </a>
    ))}
  </div>
);

export const LandingPageDocuments = ({ docs = [] }: { docs: docProps[] }) => (
  <>
    <div className="landing-page__description">
      <strong className="landing-page__description-title--secondary">
        Here's a title for you
      </strong>
      <p>
        We're the world governing body of tennis, working on behalf of our 210
        member nations.
      </p>
    </div>
    <div className="landing-page__docs">
      {docs.map(({ name, type }: docProps, key: number) => (
        <div className={`landing-page__docs-file ${type}`} key={key}>
          {name}
        </div>
      ))}
    </div>
  </>
);

export const LandingPagePublications = ({
  docs = []
}: {
  docs: docProps[];
}) => (
  <>
    <div className="landing-page__description">
      <strong className="landing-page__description-title--secondary">
        Here's a title for you
      </strong>
      <p>
        We're the world governing body of tennis, working on behalf of our 210
        member nations.
      </p>
    </div>
    <div className="landing-page__publications">
      {docs.map(({ name, type }: docProps, key: number) => (
        <div className={`landing-page__publication ${type}`} key={key}>
          <img src="./assets/images/publication.png" />
          <div className="landing-page__publication-description">
            <span>{name}</span>
            <div className="landing-page__tile-text-link">Read more</div>
          </div>
        </div>
      ))}
    </div>
  </>
);

export const LandingPageSectionTwoColumn = ({
  sections
}: {
  sections: sectionProps[];
}) => (
  <div className="landing-page__section-two-column">
    {sections.map(({ name, description }: sectionProps, key: number) => (
      <div key={key}>
        <strong>{name}</strong>
        <p>{description}</p>
      </div>
    ))}
  </div>
);

export const LandingPageTitle = ({
  align = "left",
  gradient = false,
  backgroundImage = "./assets/images/landing_page_bg_1.png",
  description,
  subtext,
  title,
  linkText,
  linkClass,
  short,
  isLight,
  borderBottom,
  iosLink,
  androidLink
}: {
  align?: string;
  gradient?: boolean;
  backgroundImage?: string;
  description?: string;
  subtext?: string;
  title?: string;
  linkText?: string;
  short?: boolean;
  linkClass?: string;
  isLight?: boolean;
  borderBottom?: boolean;
  iosLink?: string;
  androidLink?: string;
}) => {
  return (
    <div
      className={`landing-page__tile-bg${short ? " short" : ""} ${align}${
        gradient ? " gradient" : ""
      }${isLight ? " isLight" : ""}${borderBottom ? " borderBottom" : ""}`}
      style={{
        backgroundImage: `url("${backgroundImage}")`
      }}
    >
      <div className="container">
        <div className="landing-page__tile-bg-text">
          {subtext ? <span>{subtext}</span> : null}
          {title ? <strong>{title}</strong> : null}
          {description ? <p>{description}</p> : null}
          {linkText ? (
            <div
              className={`landing-page__tile-bg-text-link${
                linkClass ? linkClass : ""
              }`}
            >
              {linkText}
            </div>
          ) : null}
          {iosLink ? (
            <a
              className="btn__app-btn--ios btn btn--clear"
              href={iosLink}
              target="_blank"
            >
              IOS
            </a>
          ) : null}
          {androidLink ? (
            <a
              className="btn__app-btn--android btn btn--clear"
              href={androidLink}
              target="_blank"
            >
              Andriod
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

interface Props {
  hasTitle?: boolean;
  numberOfArticles?: number;
  olympics?: boolean;
}

export const LandingPageArticles = ({
  hasTitle = true,
  numberOfArticles = 3,
  olympics = false
}: Props) => {
  const articles = [];

  for (let i = 0; i < numberOfArticles; i++) {
    articles.push(
      <li key={i} className={`option--${i == 0 ? 1 : 2}`}>
        <a>
          <img alt="Text" src="./assets/images/homepage_thumb_1.png" />
        </a>
        <div className="landing-page__header-link-text">
          {olympics ? (
            <>
              <p className="landing-page__header-link-text">Masters</p>
              <a href="/" className="landing-page__header-link-chevron">
                Text name will goe here
              </a>
              <a href="/" className="landing-page__header-link-btn">
                Read more
              </a>
            </>
          ) : (
            <>
              <span>Subtext</span>
              <a href="/" className="landing-page__header-link">
                Text name will goe here
              </a>
            </>
          )}
        </div>
      </li>
    );
  }

  const isParalympics = location.href.indexOf("paralympics") >= 0;

  return (
    <div
      className={`grid-cta-module page-section${isParalympics ? " para" : ""}`}
    >
      <section className="page-section__inner landing-page__header">
        {hasTitle ? (
          <div className="landing-page__header-title">
            {olympics ? null : <small>About ITF</small>}
            <strong>
              Things that we all really ought to know about the ITF
            </strong>
          </div>
        ) : null}
        <ul className="landing-page__header-links rounded">{articles}</ul>
      </section>
    </div>
  );
};

export const Tile = ({
  imageSrc,
  subtext,
  title,
  description,
  children,
  linkText,
  direction = "left"
}: any) => (
  <div className={`page-section landing-page__tile ${direction}`}>
    <div className="page-section__inner">
      <div className="landing-page__tile-image">
        <img alt="Text" src={imageSrc} />
      </div>
      <div className="landing-page__tile-text">
        {subtext ? <span>{subtext}</span> : null}
        <strong>{title}</strong>
        {description ? <p>{description}</p> : null}
        {children}
        <div className="landing-page__tile-text-link">{linkText}</div>
      </div>
    </div>
  </div>
);

export const LandingPageFooter = ({ linkChevrons, successStories }: any) => (
  <section className="page-section">
    <div
      className={`page-section__inner landing-page__header${
        linkChevrons ? " link-chevrons" : ""
      }${successStories ? " success-stories" : ""}`}
    >
      <div className="landing-page__header-title">
        <strong>Other events</strong>
      </div>
      <ul className="landing-page__header-links rounded">
        {[1, 2, 3].map((key: number) => (
          <li key={key}>
            <img alt="Text" src="./assets/images/20181029_0324.jpg" />
            <div className="landing-page__header-link-text">
              <span>Subtext</span>
              {linkChevrons ? (
                <p className="landing-page__header-link">
                  Some text to go here as you wish
                </p>
              ) : null}
              {linkChevrons ? (
                <a className="landing-page__header-link-chevron" href="/">
                  <span>Text name will goe here</span>
                </a>
              ) : (
                <p className="landing-page__header-link">
                  Some text to go here as you wish
                </p>
              )}{" "}
              {key === 2 ? (
                <a href="/" className="landing-page__header-link-btn">
                  Read more
                </a>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export const Generic2by2 = () => {
  return (
    <div className="generic-2by2">
      <div className="generic-2by2__item">
        <h3>Approved Balls</h3>
        <p>
          Liquorice gingerbread dessert icing jujubes gummi bears tiramisu ice
          cream pudding.
        </p>
        <a href="#">
          <img src="./assets/images/Tennis-Tech/2by2.png" />
        </a>
        <p>
          <a href="#0">View 2019 Approved Balls</a>
        </p>
      </div>
      <div className="generic-2by2__item">
        <h3>Approved Balls</h3>
        <p>
          Liquorice gingerbread dessert icing jujubes gummi bears tiramisu ice
          cream pudding.
        </p>
        <a href="#">
          <img src="./assets/images/Tennis-Tech/2by2.png" />
        </a>
        <p>
          <a href="#0">View 2019 Approved Balls</a>
        </p>
      </div>
      <div className="generic-2by2__item">
        <h3>Approved Balls</h3>
        <p>
          Liquorice gingerbread dessert icing jujubes gummi bears tiramisu ice
          cream pudding.
        </p>
        <a href="#">
          <img src="./assets/images/Tennis-Tech/2by2.png" />
        </a>
        <p>
          <a href="#0">View 2019 Approved Balls</a>
        </p>
      </div>
      <div className="generic-2by2__item">
        <h3>Approved Balls</h3>
        <p>
          Liquorice gingerbread dessert icing jujubes gummi bears tiramisu ice
          cream pudding.
        </p>
        <a href="#">
          <img src="./assets/images/Tennis-Tech/2by2.png" />
        </a>
        <p>
          <a href="#0">View 2019 Approved Balls</a>
        </p>
      </div>
    </div>
  );
};

const GenericLandingPage = ({ children }: { children: JSX.Element }) => {
  return (
    <>
      <div className="landing-page">
        <LandingPageArticles />
        <LandingPageTitle {...landingPageProps} />

        <Tile
          imageSrc="./assets/images/generic_ceremony.png"
          subtext="Rand"
          title="Random title will eventually go here but then again"
          link="/"
          linkText="Find out more"
        />

        <Tile
          imageSrc="./assets/images/generic_ceremony.png"
          subtext="Rand"
          title="Random title will eventually go here but then again"
          link="/"
          description="Discover who we are and how the organisation is structured."
          linkText="Find out more"
          direction="right"
        />

        <LandingPageFooter />
        {children}
      </div>
    </>
  );
};

export default GenericLandingPage;
